import { delay } from "@outschool/ui-utils";

/**
 * Async wait for a variable till it gets defined in window
 *
 * • Usage Example: Waiting for async window.FB var to be initialized
 * - eg: `waitForVar('FB').then(FB => FB.test())`
 */
export async function waitForVar<T extends keyof Window>(
  name: T,
  {
    pollFrequency = 1000,
    retries = 100
  }: {
    pollFrequency?: number;
    retries?: number;
  } = { pollFrequency: 1000, retries: 100 }
): Promise<Window[T]> {
  // eslint-disable-next-line no-prototype-builtins
  if (window && window.hasOwnProperty(name)) {
    return window[name];
  }
  if (retries <= 0) {
    throw new Error(
      `Variable did not load in after ${pollFrequency * retries} ms`
    );
  }
  await delay(pollFrequency);
  return waitForVar(name, { pollFrequency, retries: retries - 1 });
}
